import React from 'react'
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import useStyles from './style';


const SpendCardViewer = (props) => {
    const { data, blockState, isLoading } = props
    const classes = useStyles();
    
    const headerValue = (formData, value, obj) => {
        if (formData?.[value]) {
            if(obj?.isAmountField && obj?.isPound) {
                return formatPoundAmount(typeof formData?.[value] === 'object' ? formData?.[value]?.value : formData?.[value], obj?.isAmountField, obj?.isPound);
            }
            if(obj?.isAmountField && obj?.isDoller) {
                return formatDollerAmount(typeof formData?.[value] === 'object' ? formData?.[value]?.value : formData?.[value], obj?.isAmountField, obj?.isDoller);
            }
            if(obj?.isAmountField && obj?.isPercentage) {
                return formatPercentageAmount(typeof formData?.[value] === 'object' ? formData?.[value]?.value : formData?.[value], obj?.isAmountField, obj?.isPercentage);
            }
            if(obj?.isAmountField) {
                return formatAmount(typeof formData?.[value] === 'object' ? formData?.[value]?.value : formData?.[value], obj?.isAmountField);
            }
            return typeof formData?.[value] === 'object' ? formData?.[value]?.value : formData?.[value];
        }
        return '-';
    }
    const formatPoundAmount = (val, isAmountField, showPound) => {
        if (isAmountField && showPound) {
            const cleaned = String(val).replace(/[$,]/g, '').trim();
            const num = Number(cleaned);
            if (!isNaN(num)) {
                return `£${num.toLocaleString()}`;
            }
        }
        return val;
    };   
    const formatAmount = (val, isAmountField) => {
        console.log('formatAmount**props', val, isAmountField);
        if (isAmountField) {
            const cleaned = String(val).replace(/[$,]/g, '').trim();
            const num = Number(cleaned);
            if (!isNaN(num)) {
                return num.toLocaleString();
            }
        }
        return val;
    };
    const formatDollerAmount = (val, isAmountField, showDoller) => {
        console.log('formatDollerAmount**props', val, isAmountField, showDoller);
        if (isAmountField && showDoller) {
            const cleaned = String(val).replace(/[$,]/g, '').trim();
            const num = Number(cleaned);
            if (!isNaN(num)) {
                return `$${num.toLocaleString()}`;
            }
        }
        return val;
    };
    const formatPercentageAmount = (val, isAmountField, showPercentage) => {
        console.log('formatPercentageAmount**props', val, isAmountField, showPercentage);
        if (isAmountField && showPercentage) {
            const cleaned = String(val).replace(/[%,]/g, '').trim();
            const num = Number(cleaned);
            if (!isNaN(num)) {
                // If the number is less than 1 (and not 0), it's a decimal (e.g., 0.022), convert to percentage (2.2%)
                if (num < 1 && num !== 0) {
                    const percentage = num * 100;
                    // Format to show up to 1 decimal place, removing trailing zeros
                    return `${percentage.toFixed(1).replace(/\.?0+$/, '')}%`;
                }
                // If the number is already >= 1 or is 0, assume it's already a percentage value
                return `${num.toLocaleString()}%`;
            }
        }
        return val;
    };
    return (
        <div className={classes.spendCardContainer}>
            {
                data?.map((item, index) => (
                    <div key={index} className={classes.spendCardItem}>
                        <img src={item.icon} alt={item.label} className={classes.spendCardIcon} />
                        <div className={classes.spendCardContentWrapper}>
                            <Typography className={classes.spendCardLabel}>{item.label}</Typography>
                            {isLoading ? (
                                <CircularProgress className={classes.spendCardLoader} size={12} />
                            ) : (
                                <Typography className={classes.spendCardValue}>{headerValue(blockState, item.value, item)}</Typography>
                            )}
                        </div>
                    </div>
                ))
            }
        </div>
    )
}

export default SpendCardViewer